//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'

export default {

    name: 'ProfileTabProducts',

    mixins: [ProfileData],

    props: {
        company: {
        },
    },

    data() {
        return {
            products: {}
        }
    },

    async fetch() {

        try {
            const response = await this.$store.dispatch('profile/GET_PRODUCTS', this.company.id)
            this.products = response
        } catch (e) {
            this.$logger.captureException(e)
        }

    }

}

